$(document).ready(function () {
  
  window.fbAsyncInit = function() {
    FB.init({
      appId: '2402843226633592',
      autoLogAppEvents: true,
      xfbml: true,
      version: 'v5.0'
    });
  };
  
  (function(d, s, id) {
    var js, fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) {return;}
    js = d.createElement(s); js.id = id;
    js.src = "https://connect.facebook.net/en_US/sdk.js";
    fjs.parentNode.insertBefore(js, fjs);
  }(document, 'script', 'facebook-jssdk'));
  
  $(document).on("click", ".social-sharing-bar li a", function (e) {
    e.preventDefault();
    
    var shareurl = window.location.href;
    var winHeight = 350;
    var winWidth = 520;
    var winTop = (screen.height / 2) - (winHeight / 2);
    var winLeft = (screen.width / 2) - (winWidth / 2);
    var articleTitle = $("h1").text();
    var socialClass = $(this).attr('class');
    var twitterCopy = articleTitle + " " + shareurl + " via @braindo";
    var emailHref = "mailto:?Subject="+encodeURI(articleTitle)+"&Body=Here is the link ot the article: "+encodeURI(shareurl);
    var opts = 'status=1' +
    ',width='  + winWidth  +
    ',height=' + winHeight +
    ',top='    + winTop    +
    ',left='  + winLeft;

    switch (socialClass) {

    case ('icon-facebook'):
      FB.ui({
        method: 'share',
        href: shareurl
      }, function (response) {});
      break;

    case ('icon-mail'):
      $(this).attr("href", emailHref);
      window.location = $(this).attr("href");
      break;

    case ('icon-twitter'):
      shareurl = 'http://twitter.com/intent/tweet?text='+encodeURI(twitterCopy);
      window.open(shareurl, 'sharer', opts);
      break;

    case ('icon-linkedin'):
      shareurl = 'http://www.linkedin.com/shareArticle?mini=true&url='+encodeURI(twitterCopy);
      window.open(shareurl, 'sharer', opts);
      break;

    }

  });

  if ($(".social-sharing-bar").length) {
    
    var $socialSharingBar = $(".social-sharing-bar");
    var socialSharingBarWaypoint = new Waypoint.Sticky({
      element: $socialSharingBar[0],
      stuckClass: 'fixed-social-bar',
      wrapper: '<div class="social-bar-wrapper" />',
      offset: function () {
        return $(window).height() * 0.4;
      }
    });
  }
});